import type {IBannerData} from '@core-client/ads/banner/data/IBannerData';
import {BannerView} from '../BannerView';

export class BannerRenderer {
    bannerView: BannerView;

    constructor(bannerView: BannerView) {
        this.bannerView = bannerView;
    }

    // Переопределяется в подклассах
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    showBannerDiv(banner: IBannerData) {

    }
}
